import React from "react";

function Subscriptions() {
  return <div></div>;
}

export default Subscriptions;
